import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { ForwardedRef } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../core';
import { restrictedZIndexes } from '../../utils';
import { theme } from './dropdown_menu.theme';

export type DropdownMenuRootProps = {
	trigger: JSX.Element;
	onCloseAutoFocus?: (event: Event) => void;
	onEscapeKeyDown?: (event: Event) => void;
	onPointerDownOutside?: (event: Event) => void;
	onFocusOutside?: (event: Event) => void;
	onInteractOutside?: (event: Event) => void;
	align?: DropdownMenu.DropdownMenuContentProps['align'];
} & DropdownMenu.DropdownMenuProps;

const elements = {
	content: styled(DropdownMenu.Content)`
		--contentMargin: ${coreTokens.spacing.x1};

		z-index: ${restrictedZIndexes.high};
		overflow: hidden;
		border: 1px solid ${theme.getValue('contentBorderColor')};
		border-radius: ${theme.getValue('contentBorderRadius')};
		background: ${theme.getValue('contentBackground')};
		box-shadow: ${theme.getValue('contentBoxShadow')};
		padding: ${coreTokens.spacing.x0_5} 0;
		display: flex;
		flex-direction: column;
		max-height: min(calc(var(--radix-dropdown-menu-content-available-height) - var(--contentMargin)), 400px);
		max-width: calc(var(--radix-dropdown-menu-content-available-width));
		overflow: hidden;

		&[data-side='top'] {
			margin-bottom: var(--contentMargin);
		}

		&[data-side='bottom'] {
			margin-top: var(--contentMargin);
		}
	`,
	contentInner: styled.div`
		overflow-x: hidden;
		overflow-y: auto;
		height: 100%;
		padding: 0 ${coreTokens.spacing.x0_5};
	`,
};
export function CellulaDropdownMenuRoot(
	{
		trigger,
		children,
		onCloseAutoFocus,
		onEscapeKeyDown,
		onPointerDownOutside,
		onFocusOutside,
		onInteractOutside,
		align,
		...rest
	}: DropdownMenuRootProps,
	ref: ForwardedRef<HTMLButtonElement>,
): JSX.Element {
	return (
		<DropdownMenu.Root {...rest}>
			<DropdownMenu.Trigger ref={ref} asChild>
				{trigger}
			</DropdownMenu.Trigger>
			<DropdownMenu.Portal>
				<elements.content
					collisionPadding={8}
					loop
					onCloseAutoFocus={onCloseAutoFocus}
					onEscapeKeyDown={onEscapeKeyDown}
					onPointerDownOutside={onPointerDownOutside}
					onFocusOutside={onFocusOutside}
					onInteractOutside={onInteractOutside}
					align={align}
				>
					<elements.contentInner>{children}</elements.contentInner>
				</elements.content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
}
